import { createContext, useState, useContext } from "react";

import fcl from "../config.js"


const FlowConfigContext = createContext();

const FlowUserAccountContext = createContext();

export function useAccount() {
    return useContext(FlowUserAccountContext)
}

export function useFcl() {
    return useContext(FlowConfigContext)
}


export function FlowProvider ({ children}) {


    const [userAddress, setUserAddress] = useState(null)

    async function connectWallet () {
        await fcl.authenticate()
    }

    fcl.currentUser.subscribe(currentUser => {
        console.log("The Current User", currentUser)
        setUserAddress(currentUser.addr)
    })

    async function disconnectWallet () {
        const user = fcl.unauthenticate()
        console.log(user)
        setUserAddress(null)
    }


    return (
        <FlowConfigContext.Provider value={fcl}>
            <FlowUserAccountContext.Provider value={{address: userAddress, isConnected: userAddress !== null, connect: connectWallet, disconnect: disconnectWallet}}>
                {children}
            </FlowUserAccountContext.Provider>
        </FlowConfigContext.Provider>
    )
} 

